import { render, staticRenderFns } from "./TitlesCount.vue?vue&type=template&id=7a4dd899&scoped=true"
import script from "./TitlesCount.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitlesCount.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TitlesCount.vue?vue&type=style&index=0&id=7a4dd899&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4dd899",
  null
  
)

export default component.exports